/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import DiffusionList from 'diffusion/components/DiffusionList';
import { getTargets } from '../reducers/diffusion';
import * as DiffusionActions from '../actions/diffusion';

type Props = {
  targets: Array<Target>,
  updateTargets: (targets: Map<number, Target>) => void,
};

const mapStateToProps = state => ({
  targets: getTargets(state),
});

const DiffusionCard = ({ targets, updateTargets }: Props) => (
  <DiffusionList
    targets={targets}
    onUpdate={updateTargets}
    isEditable
    attached
  />
);

export default connect(mapStateToProps, {
  updateTargets: DiffusionActions.updateTargets,
})(DiffusionCard);



// WEBPACK FOOTER //
// ./src/modules/calendar/components/DiffusionCard.js